import { render } from "./ConfirmColorModal.vue?vue&type=template&id=6eb00224&scoped=true&ts=true&lang=pug"
import script from "./ConfirmColorModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmColorModal.vue?vue&type=script&lang=ts"

import "./ConfirmColorModal.vue?vue&type=style&index=0&id=6eb00224&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb00224"]])

export default __exports__